/**
 * TanStack Query keys shared by Security Controls and the top bar's Refresh Security item (E-106).
 * One module, so the two can never disagree about which cache a refresh must invalidate.
 */
export const TREE_QUERY_KEY = ['security-controls', 'tree'] as const;
export const PENDING_MOVES_QUERY_KEY = ['security-controls', 'pending-moves'] as const;
export const MENU_CONFIG_QUERY_KEY = ['menu-config'] as const;

/** ADR-13: what a security change can affect, refreshed after every successful write. */
export const PERMISSION_QUERY_KEYS: ReadonlyArray<readonly string[]> = [
  ['effective-permissions'],
  ['auth', 'effective-permissions'],
  MENU_CONFIG_QUERY_KEY,
];
